import { BarChartIcon } from "@assets/icons";
import * as styles from "../styles";
import { LinkText } from "..";

export default function LeftCol({ tabContent }) {
    return (
        <div className={styles.colContainer}>
            <div className={styles.featTitle}>Background</div>
            <div className="mr-4">
                {tabContent?.background.map((background) => (
                    <div className="mb-3 last:mb-0">
                        {background.title && (
                            <span className="pr-2 italic">
                                {background.title}:
                            </span>
                        )}
                        {background.desc}
                    </div>
                ))}
            </div>
            <div className={styles.featCatTitle}>dataset resolution:</div>
            <div className="italic">{tabContent?.resolution}</div>
            <div className={styles.featCatTitle}>temporal frequency:</div>
            <div className="italic">{tabContent?.frequency}</div>
            {tabContent?.useCase1 && (
                <>
                    <div className={styles.featTitle}>
                        use case
                        {tabContent?.useCase1.title
                            ? ": " + tabContent?.useCase1.title
                            : " 1"}
                    </div>
                    <div>{tabContent?.useCase1.desc}</div>
                    <LinkText
                        to={tabContent?.useCase1.link}
                        external={tabContent?.useCase1.external}
                    >
                        <span className="pr-2">{tabContent?.useCase1.icon}</span>
                        {tabContent?.useCase1.linkText}
                    </LinkText>
                </>
            )}
            {tabContent?.useCase2 && (
                <>
                    <div className={styles.featTitle}>
                        use case
                        {tabContent?.useCase2.title
                            ? ": " + tabContent?.useCase2.title
                            : " 2"}
                    </div>
                    <div>{tabContent?.useCase2.desc}</div>
                    <LinkText
                        to={tabContent?.useCase2.link}
                        external={tabContent?.useCase2.external}
                    >
                        <span className="pr-2">{tabContent?.useCase2.icon}</span>
                        {tabContent?.useCase2.linkText}
                    </LinkText>
                </>
            )}
            {tabContent?.useCase3 && (
                <>
                    <div className={styles.featTitle}>
                        use case
                        {tabContent?.useCase3.title
                            ? ": " + tabContent?.useCase3.title
                            : " 3"}
                    </div>
                    <div>{tabContent?.useCase3.desc}</div>
                    <LinkText
                        to={tabContent?.useCase3.link}
                        external={tabContent?.useCase3.external}
                    >
                        <span className="pr-2">{tabContent?.useCase3.icon}</span>
                        {tabContent?.useCase3.linkText}
                    </LinkText>
                </>
            )}
            {tabContent?.datasets && (
                <>
                    <div className={styles.featTitle}>additional datasets</div>
                    <div>
                        {tabContent?.datasets.map(({ link, linkText }) => (
                            <div className="flex pb-2">
                                <div className="mt-[14px]">
                                    <BarChartIcon />
                                </div>
                                <LinkText
                                    to={link}
                                    external={true}
                                    className="pl-2"
                                >
                                    {linkText}
                                </LinkText>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
